import React from 'react'

export default ({header, children}) => (
  <section className='Personality'>
    <h4 className='Personality_header'>{header}</h4>
    <p className='Personality_content'>{children}</p>
  </section>
)
